/** Normalize Trustpilot domain from admin input or full review URL. */
export function normalizeTrustpilotDomain(raw) {
  let value = String(raw || '').trim();
  if (!value) return '';

  try {
    if (/trustpilot\.com/i.test(value)) {
      const url = new URL(value.startsWith('http') ? value : `https://${value}`);
      const segments = url.pathname.split('/').filter(Boolean);
      const reviewIdx = segments.findIndex((s) => s.toLowerCase() === 'review');
      if (reviewIdx >= 0 && segments[reviewIdx + 1]) {
        return segments[reviewIdx + 1].replace(/^www\./i, '').toLowerCase();
      }
    }
  } catch {
    // fall through
  }

  value = value.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
  return value.split('/')[0].toLowerCase();
}

/** Public Trustpilot review page for a business domain. */
export function trustpilotReviewUrl(domain, language = 'en') {
  const normalized = normalizeTrustpilotDomain(domain);
  if (!normalized) return '';
  const host = language === 'fr' || language === 'ht' ? 'fr.trustpilot.com' : 'www.trustpilot.com';
  return `https://${host}/review/${encodeURIComponent(normalized)}`;
}

/** TrustBox locale codes supported by Trustpilot widgets. */
export function trustpilotWidgetLocale(language) {
  const map = {
    en: 'en-US',
    fr: 'fr-FR',
    es: 'es-ES',
    ht: 'fr-FR',
    ru: 'en-US',
  };
  return map[String(language || '').toLowerCase()] || 'en-US';
}
